/**
 * @file
 * Pluxee edge browser script.
 */

(function ($) {
    'use strict';
    Drupal.behaviors.pluxeeEdgeBrowser = {
        attach: function (context, settings) {
            $(document).ready(function() {
                function isEdge() {
                    return navigator.userAgent.toLowerCase().search("edg") > -1;
                }

                function addEdgeClassToBody() {
                    $("body").addClass("edge-browser");
                }

                if(isEdge()) {
                    addEdgeClassToBody();
                }
            });
        }
    };
})(jQuery);
